
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class ReportVatRefundDialog extends Serenity.EntityDialog<ReportVatRefundRow, any> {
        protected getFormKey() { return ReportVatRefundForm.formKey; }
        protected getIdProperty() { return ReportVatRefundRow.idProperty; }
        protected getLocalTextPrefix() { return ReportVatRefundRow.localTextPrefix; }
        protected getNameProperty() { return ReportVatRefundRow.nameProperty; }
        protected getService() { return ReportVatRefundService.baseUrl; }
        protected getDeletePermission() { return ReportVatRefundRow.deletePermission; }
        protected getInsertPermission() { return ReportVatRefundRow.insertPermission; }
        protected getUpdatePermission() { return ReportVatRefundRow.updatePermission; }

        protected form = new ReportVatRefundForm(this.idPrefix);

    }
}